import { createFileRoute } from '@tanstack/react-router';

import { AccountingExport } from '@/features/integrations/integrations-page';

/** The person's own books as an individual owner (`/me/accounting`). */
export const Route = createFileRoute('/_app/account/accounting')({
  component: PersonalAccounting,
});

function PersonalAccounting() {
  return <AccountingExport orgId={null} />;
}
